<template>
    <MainTempComp
        ref="mainTempRef"
        :searchOption="data.searchOption"
        :handleSearch="handleSearch"
    >
        <template #header>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button type="primary" @click="handleCloseMain">关闭</el-button>
        </template>
        <template #main>
            <el-table :data="data.tableData" border style="width: 100%">
                <el-table-column
                    label="序号"
                    align="center"
                    width="50"
                    type="index"
                ></el-table-column>
                <el-table-column
                    label="洗手"
                    prop="name"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="车场"
                    prop="item.prop"
                    align="center"
                    width="300"
                >
                    <template #default="scope">
                        <div
                            v-if="
                                scope.row.parkingLotList &&
                                scope.row.parkingLotList.length
                            "
                        >
                            <div v-if="scope.row.auditStatus == 1">
                                原停车场：
                            </div>
                            <div
                                v-for="(item, index) in scope.row
                                    .parkingLotList"
                                :key="index"
                                style="
                                    margin-bottom: 6px;
                                    border-bottom: 1px solid #ccc;
                                "
                            >
                                {{ item.name }}
                            </div>
                        </div>
                        <div
                            v-if="
                                scope.row.newParkingLotList &&
                                scope.row.newParkingLotList.length &&
                                scope.row.auditStatus == 1
                            "
                        >
                            <div>新停车场：</div>
                            <div
                                v-for="(item, index) in scope.row
                                    .newParkingLotList"
                                :key="index"
                                style="
                                    margin-bottom: 6px;
                                    border-bottom: 1px solid #ccc;
                                "
                            >
                                {{ item.name }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column
					label="作业时间"
					prop="item.prop"
					align="center"
				>
					<template #default="scope">
						<div
							v-if="
								scope.row.startWorkTime && scope.row.endWorkTime
							"
						>
							<span>{{ scope.row.startWorkTime }}</span>
							<span>~</span>
							<span>{{ scope.row.endWorkTime }}</span>
						</div>
					</template>
				</el-table-column> -->
                <el-table-column
                    label="接单频次"
                    prop="orderCount"
                    align="center"
                >
                    <template #default="scope">
                        <div>
                            <span v-if="scope.row.auditStatus == 1"
                                >原接单频次：</span
                            >
                            {{ scope.row.orderCount }}
                        </div>
                        <div v-if="scope.row.auditStatus == 1">
                            新接单频次：{{ scope.row.updateOrderCount }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="审核状态"
                    prop="auditStatus"
                    align="center"
                >
                    <template #default="scope">
                        <span v-if="scope.row.auditStatus == 0">已审核</span>
                        <span v-if="scope.row.auditStatus == 1">待审核</span>
                        <span v-if="scope.row.auditStatus == 2">已拒绝</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="" align="center">
                    <template #default="scope">
                        <div v-if="scope.row.auditStatus == 1">
                            <div class="btnBox">
                                <el-button
                                    @click="handlePass(scope.row)"
                                    type="primary"
                                    size="mini"
                                    >审核通过</el-button
                                >
                            </div>
                            <div class="btnBox" style="margin-top: 10px">
                                <el-button
                                    @click="handleRefuse(scope.row)"
                                    type="danger"
                                    size="mini"
                                    >审核拒绝</el-button
                                >
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </MainTempComp>
    <el-dialog title="提示" v-model="data.dialogVisible" width="30%">
        <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入拒绝原因"
            v-model.trim="data.refuseReason"
        />
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="data.dialogVisible = false" size="mini"
                    >取 消</el-button
                >
                <el-button @click="handleRefuseSave" type="danger" size="mini"
                    >审核拒绝</el-button
                >
            </span>
        </template>
    </el-dialog>
</template>

<script>
import {
    apiParkingLotWasherList,
    apiParkingLotAuditWasher,
} from "@/api/requestApis.js";
import { reactive, ref, onMounted, provide, inject } from "vue";
import { ElMessage } from "element-plus";
import { ElMessageBox } from "element-plus";
export default {
    setup() {
        const toggleView = inject("toggleView");
        const data = reactive({
            currentData: {},
            refuseReason: "",
            dialogVisible: false,
            tableData: [],
            searchOption: [
                {
                    name: "状态",
                    type: "select",
                    key: "auditStatus",
                    value: "",
                    options: [
                        { value: 0, label: "已审核" },
                        { value: 1, label: "待审核" },
                        { value: 2, label: "已拒绝" },
                    ],
                },
            ],
        });
        onMounted(() => {
            handleSearch();
        });

        const mainTempRef = ref(null);
        const handleSearch = async () => {
            const res = await apiParkingLotWasherList({
                size: mainTempRef.value.pageSize,
                current: mainTempRef.value.currentPage,
                ...mainTempRef.value.searchParams,
            });
            mainTempRef.value.setTotalValue(res.total || 0);
            data.tableData = res.list || [];
        };
        const handlePass = (val) => {
            ElMessageBox.alert("确定通过审核吗？", {
                confirmButtonText: "确定",
                callback: async (action) => {
                    if (action === "confirm") {
                        await apiParkingLotAuditWasher({
                            id: val.id,
                            auditStatus: 0,
                        });
                        handleSearch();
                    }
                },
            });
        };
        const handleRefuse = (val) => {
            data.currentData = val;
            data.dialogVisible = true;
        };
        const handleRefuseSave = async () => {
            if (!data.refuseReason) {
                ElMessage.error("请输入拒绝原因");
                return;
            }
            await apiParkingLotAuditWasher({
                id: data.currentData.id,
                auditStatus: 2,
                refuseReason: data.refuseReason,
            });
            data.dialogVisible = false;
            handleSearch();
        };
        const handleCloseMain = () => {
            toggleView("showMain", true);
            toggleView("showWashingYard", false);
        };
        provide("handleSearch", handleSearch);
        return {
            handleCloseMain,
            handleRefuseSave,
            handlePass,
            handleRefuse,
            mainTempRef,
            data,
            handleSearch,
        };
    },
};
</script>

<style scoped>
.btnBox {
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>
